module.exports = __webpack_public_path__ + "static/bank-a54f6c67862a9db2d54e8cad4c6e9a8b.svg";